// /english — the dashboard. One card per story in english/stories/.
//
// This is the front door on purpose. The coach bills per audio minute and asks
// you to speak; arriving there should be a choice you made about a particular
// story, not the first thing that loads.

import { useEffect, useState } from "react";
import { fetchTopics } from "../services/englishApi";
import CoachShell from "../components/english/CoachShell";
import LessonCard from "../components/english/LessonCard";

export default function EnglishDashboardPage() {
  const [lessons, setLessons] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    fetchTopics()
      .then((data) => {
        setLessons(data.topics);
        setStatus("ready");
      })
      .catch(() => setStatus("error"));
  }, []);

  const totals = lessons.reduce(
    (acc, l) => ({
      phrases: acc.phrases + (l.phrase_count || 0),
      practiced: acc.practiced + (l.practiced || 0),
    }),
    { phrases: 0, practiced: 0 },
  );

  return (
    <CoachShell
      back={{ to: "/articles", label: "Articles" }}
      title="English Speaking Coach"
      subtitle={
        status === "ready"
          ? `${lessons.length} lesson${lessons.length === 1 ? "" : "s"} · ${totals.practiced}/${totals.phrases} phrases practised`
          : "Loading…"
      }
    >
      {status === "loading" && <p className="text-sm text-slate-500">Loading lessons…</p>}

      {status === "error" && (
        <p className="text-sm text-rose-400">
          Could not load the lessons — the backend did not answer.
        </p>
      )}

      {status === "ready" && lessons.length === 0 && (
        <p className="text-sm text-slate-500">
          No stories yet. Drop a markdown file in <code>english/stories/</code> and
          reload.
        </p>
      )}

      {status === "ready" && lessons.length > 0 && (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {lessons.map((lesson) => (
            <LessonCard key={lesson.slug} lesson={lesson} />
          ))}
        </div>
      )}

      {/* No Knowledge Base link here any more — the header's back link goes to
          /articles, and two ways out on one screen is one too many. */}
      <p className="mt-10 text-xs text-slate-600">
        Stories come from <code>english/stories/</code>, their phrase lists from{" "}
        <code>english/phrases/</code>, and narration from{" "}
        <code>english/audio/</code>.
      </p>
    </CoachShell>
  );
}
